<script>
  import { onMount } from "svelte";
  import { Buttons } from "../../../../Controller/system/components/buttons/buttons";
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();
  export let model;
  export let newButton;
  export let item;
  newButton = new Buttons();
  item = newButton.btndefault;

  bottonmodel(model);

  function bottonmodel(modelbutton) {
    switch (modelbutton) {
      case "create":
        item = newButton.btncrear;
        break;
      case "save":
        item = newButton.btnGuardar;
        break;
      case "cancel":
        item = newButton.btncancelar;
        break;
      case "add":
        item = newButton.btncrear;
        item.text = 'Añadir nuevo dispostivo';

        break;
      case "tDelete":
        item = newButton.btncrear;
        item.ico = 'bi bi-trash'
        item.style = 'btn-outline-danger'
        item.text = 'Eliminar';
        break;
      case "detect":
        item = newButton.btncrear;
        item.text = "Detectar";
        break;
      default:
        item = newButton.btndefault;
        break;
    }
  }

  export function statusButton(bool) {
    item.carga = bool;
  }

  export function load(bool) {
    if (bool) {
      item.carga = false;
      item.status = true;
    } else {
      item.carga = true;
      item.status = false;
    }
  }

export function setTextButton(text) {
    item.text = text;
  }

  function handleClick() {
    dispatch("activated", {
      model,
      timestamp: Date.now(),
    });
  }
</script>

{#if item.status}
  <button class="btn {item.style} m-1" on:click={handleClick}
    >{item.text}
    <i class={item.ico}></i>
  </button>
{/if}

{#if item.carga}
  <div class="spinner-grow" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
{/if}

